export { default as UserRoundIcon } from '~icons/lucide/user-round';
